export default __webpack_public_path__ + "static/media/our-mission-desktop.e224c58b.png";